import { FormEvent } from 'react';
import { FallbackRequest } from '../../types/fallback';
import { Form, FormField, FormLabel, FormInput, FormSelect, FormTextarea, Button } from '../ui';

interface FallbackRequestFormProps {
  request: FallbackRequest | null;
  assistants: any[];
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
  isEditing: boolean;
}

function FallbackRequestForm({
  request,
  assistants,
  onSubmit,
  isLoading,
  onClose,
  isEditing,
}: FallbackRequestFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      {!isEditing && (
        <>
          <FormField>
            <FormLabel htmlFor="assistant_id" required>
              Assistente
            </FormLabel>
            <FormSelect
              id="assistant_id"
              name="assistant_id"
              defaultValue={request?.assistant_id}
              required
            >
              <option value="">Selecione um assistente</option>
              {assistants.map(assistant => (
                <option key={assistant.id} value={assistant.id}>
                  {assistant.name}
                </option>
              ))}
            </FormSelect>
          </FormField>
        </>
      )}

      {isEditing && (
        <>
          <FormField>
            <FormLabel htmlFor="contact">Identificador do Contato</FormLabel>
            <FormInput id="contact" name="contact" defaultValue={request?.contact || ''} readOnly />
          </FormField>

          <FormField>
            <FormLabel htmlFor="contact_name">Nome do Contato</FormLabel>
            <FormInput
              id="contact_name"
              name="contact_name"
              defaultValue={request?.contact_name || ''}
              readOnly
            />
          </FormField>
        </>
      )}

      <FormField>
        <FormLabel htmlFor="question" required>
          Pergunta
        </FormLabel>
        <FormTextarea
          id="question"
          name="question"
          defaultValue={request?.question}
          required={!isEditing}
          rows={4}
          readOnly={isEditing}
        />
      </FormField>

      {isEditing && (
        <>
          <FormField>
            <FormLabel htmlFor="human_response" required={request?.status === 'pending'}>
              Resposta Humana
            </FormLabel>
            <FormTextarea
              id="human_response"
              name="human_response"
              defaultValue={request?.human_response || ''}
              required={request?.status === 'pending'}
              rows={6}
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="final_response">Resposta Final</FormLabel>
            <FormTextarea
              id="final_response"
              name="final_response"
              defaultValue={request?.final_response || ''}
              rows={6}
              readOnly={request?.status !== 'awaiting_finalization'}
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="status" required>
              Status
            </FormLabel>
            <FormSelect id="status" name="status" defaultValue={request?.status} required>
              <option value="pending">Pendente</option>
              <option value="awaiting_finalization">Aguardando</option>
              <option value="completed">Concluído</option>
            </FormSelect>
          </FormField>
        </>
      )}

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {isEditing ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default FallbackRequestForm;
